import { render } from "./transferFunds.vue?vue&type=template&id=2cef7f0b"
import script from "./transferFunds.vue?vue&type=script&lang=js"
export * from "./transferFunds.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__